import { PRACTICE_EDITION_WHITELABEL } from "./constants";

const textLabels = {
  epic: {
    departmentLabelText: "Department",
  },
  pe: {
    departmentLabelText: "Location",
  },
};

export const TEXT_LABELS = PRACTICE_EDITION_WHITELABEL
  ? textLabels.pe
  : textLabels.epic;
